import { useTranslation } from "react-i18next";
import "./PageLoading.css";

const variants = {
  default: "page-loading--default",
  fullscreen: "page-loading--fullscreen",
  compact: "page-loading--compact",
};

/**
 * Full-page loading UI (spinner + translated "loading") — same pattern as DetailsLocation.
 * @param {"default" | "fullscreen" | "compact"} variant
 */
export default function PageLoading({ variant = "default", className = "" }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar" || i18n.language === "ur";
  return (
    <div
      className={`page-loading ${variants[variant]} ${isRTL ? "rtl" : ""} ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <div className="page-loading__spinner" aria-hidden />
      <p>{t("loading")}</p>
    </div>
  );
}
